<template>
  <v-snackbar v-model="errors" top color="error" :timeout="timeout">
    <v-alert type="error" prominent dense>
      <v-row v-for="(error, index) in errors" :key="index" align="center">
        <v-col> {{ error.detail }}</v-col>
        <v-col cols="auto">
          <icon-button icon="mdi-close" @click="errors.splice(index)" />
        </v-col>
      </v-row>
    </v-alert>
  </v-snackbar>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import IconButton from '@/components/button/IconButton.vue';
import { namespace } from 'vuex-class';
import { ErrorInterface } from '@/store/modules/errors';

const Errors = namespace('Errors');

@Component({
  components: { IconButton },
})
export default class Alert extends Vue {
  private readonly timeout = 10000;

  created() {
    setTimeout(() => {
      this.updateErrors([]);
    }, this.timeout);
  }

  @Prop() readonly errors!: [];

  @Errors.Action
  public updateErrors!: (errors: ErrorInterface[]) => void;
}
</script>
